var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payments" },
    [
      _vm.paymentsSpinner
        ? _c(
            "div",
            { staticClass: "payments__spinner" },
            [
              _c("v-progress-circular", { attrs: { indeterminate: "" } }),
              _vm._v(
                "\n    " + _vm._s(_vm.$t("Transaction.PleaseWait")) + "\n  "
              )
            ],
            1
          )
        : _c("div", [
            (!_vm.mobileBigAndBelow && _vm.brandTemplate === "generic_2") ||
            _vm.brandTemplate !== "generic_2"
              ? _c("h2", { staticClass: "payments__title" }, [
                  _vm._v(_vm._s(_vm.$t("Transaction.Cashier")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "payments__instruments" }, [
              _vm.depositType
                ? _c(
                    "div",
                    _vm._l(_vm.depositItems, function(item, index) {
                      return _c(item.is, {
                        key: index,
                        ref: item.type || item.is,
                        refInFor: true,
                        tag: "component",
                        class: [
                          "payments__instruments_item",
                          item.type || "",
                          { diss: !_vm.customerCanDeposit }
                        ],
                        attrs: { type: item.type },
                        nativeOn: {
                          click: function($event) {
                            return _vm.xtremepushEvent.apply(void 0, item.event)
                          }
                        }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.withdrawType
                ? _c(
                    "div",
                    _vm._l(_vm.withdrawalItems, function(item, index) {
                      return _c(item.is, {
                        key: index,
                        tag: "component",
                        nativeOn: {
                          click: function($event) {
                            return _vm.xtremepushEvent.apply(void 0, item.event)
                          }
                        }
                      })
                    }),
                    1
                  )
                : _vm._e()
            ])
          ]),
      _vm._v(" "),
      _c("PNMEventDispatcher"),
      _vm._v(" "),
      _c("NuveiEventDispatcher")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-460a8ee2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460a8ee2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Payments.vue
// module id = null
// module chunks = 